var React = require('react');

function PersonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m437.02 330.98c-27.883-27.882-61.071-48.523-97.281-61.018 38.782-26.711 64.261-71.414 64.261-121.962 0-81.607-66.393-148-148-148s-148 66.393-148 148c0 50.548 25.479 95.251 64.262 121.962-36.21 12.495-69.398 33.136-97.281 61.018-48.352 48.353-74.981 112.64-74.981 181.02h40c0-119.103 96.897-216 216-216s216 96.897 216 216h40c0-68.38-26.629-132.667-74.98-181.02zm-181.02-74.98c-59.551 0-108-48.448-108-108s48.449-108 108-108 108 48.448 108 108-48.449 108-108 108z"}));
}

PersonIcon.defaultProps = {"enableBackground":"new 0 0 512 512","viewBox":"0 0 512 512"};

module.exports = PersonIcon;

PersonIcon.default = PersonIcon;
